import React from 'react';

import { HeaderBox, HeaderBoxProps } from '_lib/featureComponents/HeaderBox/HeaderBox';

import { TextBlockTypography, TextBlockTypographyProps } from '../TextBoxTypography/TextBoxTypography';

export type HeaderTextBlockProps = Omit<HeaderBoxProps, 'children'> &
  Pick<TextBlockTypographyProps, 'text' | 'defaultTextValue'>;

export const HeaderTextBlock = (props: HeaderTextBlockProps) => {
  const { text, defaultTextValue, ...otherProps } = props;

  return (
    <HeaderBox {...otherProps}>
      <TextBlockTypography text={text} defaultTextValue={defaultTextValue} />
    </HeaderBox>
  );
};
